module.exports = __webpack_public_path__ + "img/case7.4073350d.png";